export default "__VITE_ASSET__DzVq3LRi__"